import * as React from 'react';
import { Container, Loading, Row, Spacer } from '@nextui-org/react';

interface AppFullWidthLoaderProps {}

/**
 * @name AppFullWidthLoader
 * @description tbd...
 */
export function AppFullWidthLoader(_props: AppFullWidthLoaderProps) {
  return (
    <Container>
      <Spacer />
      <Row align="center" justify="center">
        <Loading />
      </Row>
    </Container>
  );
}
